import { render, staticRenderFns } from "./DIadmin.vue?vue&type=template&id=53f7c424&scoped=true"
import script from "./DIadmin.vue?vue&type=script&lang=js"
export * from "./DIadmin.vue?vue&type=script&lang=js"
import style0 from "./DIadmin.vue?vue&type=style&index=0&id=53f7c424&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f7c424",
  null
  
)

export default component.exports